export const isServiceUnavailableError = (error: unknown): boolean => {
  return (error as {status?: number})?.status === 503;
};
